<template>
  <div class="ai-friend-message">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData"></ConfigTable>
  </div>
</template>

<script>
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import LongText from '../roleManage/components/LongText.vue';
import aiFriendApi from '../../../api/aiFriendManage';
import { Switch } from 'element-ui';
import { appOptions, getLabelTextWithValue, toggleOptions } from '../../config';

const searchConfig = [
  { type: 'select', placeholder: '选择App', key: 'appId', options: appOptions },
  { type: 'input', placeholder: '消息ID搜索', key: 'messageId' },
  { type: 'input', placeholder: '角色ID搜索', key: 'aiRoleId' },
  { type: 'input', placeholder: '会话ID搜索', key: 'sessionId' },
  { type: 'input', placeholder: '用户ID搜索', key: 'userId' },
  { type: 'select', placeholder: '是否用户发送', key: 'isUserMsg', options: toggleOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '应用', key: 'appId', width: 100, valueHandler: (val) => getLabelTextWithValue(appOptions, val) },
  {
    name: '消息内容', key: 'content', width: 250, component: LongText, props(value, ctx) {
      return {
        text: value,
        previewAlways: true,
        isDialogDetail: true,
        sessionId: ctx.sessionId
      }
    }
  },
  {
    name: '是否为用户发送', key: 'isUserMsg', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  { name: '会话ID', key: 'sessionId' },
  { name: '角色ID', key: 'aiRoleId' },
  { name: '用户ID', key: 'userId' },
  {
    name: '是否已读', key: 'readStatus', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  { name: '元数据', key: 'metadata' },
  { name: '发送时间', key: 'sentTime', valueHandler: changeDate },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  // { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendMessageList',
  components: { ConfigTable },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getAiMessageList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai女友聊天记录失败：', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-message {

  /deep/ .el-button {
    padding: 9px 15px;
  }
}
</style>